import { getMaster, putMaster, getOperation, fetchMaster } from "utils/api";

export const getPaperRollList = async (params) => {
  return await getMaster("/tools/thermal-paper", {
    ...params,
  });
};

export const sendPaperRollEmail = async (requestId) => {
  return await fetchMaster(`/tools/thermal-paper/email/${requestId}`, {});
};

export const getPaperRollDetail = async (requestId) => {
  return await getMaster(`/tools/thermal-paper/${requestId}`);
};

export const updatePaperRollDetail = async (requestId, params) => {
  return await putMaster(`/tools/thermal-paper/${requestId}`, params);
};

export const createPaperRollRequest = async (params) => {
  return await fetchMaster(`/tools/thermal-paper/`, params);
};

export const updateStatus = async (params) => {
  return await putMaster("/tools/thermal-paper", {
    ...params,
  });
};

export const queryMerchant = async (params) => {
  return await getOperation("/merchant/detail", {
    ...params,
  });
};

export const queryMerchantDetail = async (merchantId) => {
  return await getMaster(`/tools/merchant/${merchantId}`);
};
